import { PageHeader } from '../layouts/Shells';
import { EmptyState } from '../components/ui';

const FUTURE = 'This module arrives in a later phase.';

function ModulePlaceholder({ title }: { title: string }) {
  return (
    <>
      <PageHeader title={title} description="Placeholder only." />
      <EmptyState title={`${title} is not available yet`} description={FUTURE} />
    </>
  );
}

export function HomePage() {
  return (
    <>
      <PageHeader title="Home" description="Phase 1 foundation shell." />
      <EmptyState
        title="Welcome to the TAP Creative Operations Hub"
        description="Application modules arrive in later phases."
      />
    </>
  );
}
export function MyTasksPage() {
  return <ModulePlaceholder title="My Tasks" />;
}
export function SupplierReviewsPage() {
  return <ModulePlaceholder title="Supplier Reviews" />;
}
export function NotFoundPage() {
  return (
    <main className="foundation-page">
      <section className="foundation-card" aria-labelledby="nf-title">
        <h1 id="nf-title">Page not found</h1>
        <p className="lede">That page does not exist.</p>
        <a className="ui-button ui-button--primary ui-button--md" href="/">
          Go home
        </a>
      </section>
    </main>
  );
}
